/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BotInListDTO,
  BotOptionDTO,
  BotTableRequest,
  BotTableResponse,
  CreateBotRequest,
  EmailSendingLogTableResponse,
  FeedbackSettingsResponse,
  FullBotUi,
  LeadSettingsResponse,
  ToolSettingsResponse,
  TranscriptRoutingSettingsResponse,
  UpdateBotFeedbackSettingsRequest,
  UpdateBotLeadSettingsRequest,
  UpdateBotRequest,
  UpdateBotToolSettingsRequest,
  UpdateTranscriptRoutingRequest,
} from '../models';

export interface CreateBotOperationRequest {
    createBotRequest: CreateBotRequest;
}

export interface DeleteByPublicBotIdRequest {
    publicId: string;
}

export interface GetBotByIdRequest {
    publicId: string;
}

export interface GetBotLeadSettingsRequest {
    botPublicId: string;
}

export interface GetBotToolSettingsRequest {
    botPublicId: string;
}

export interface GetBotsTableRequest {
    botTableRequest: BotTableRequest;
}

export interface GetEmailSendingLogsRequest {
    botPublicId: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetTranscriptRoutingSettingsRequest {
    botPublicId: string;
}

export interface UpdateBotOperationRequest {
    updateBotRequest: UpdateBotRequest;
}

export interface UpdateBotFeedbackSettingsOperationRequest {
    updateBotFeedbackSettingsRequest: UpdateBotFeedbackSettingsRequest;
}

export interface UpdateBotLeadSettingsOperationRequest {
    updateBotLeadSettingsRequest: UpdateBotLeadSettingsRequest;
}

export interface UpdateBotToolSettingsOperationRequest {
    updateBotToolSettingsRequest: UpdateBotToolSettingsRequest;
}

export interface UpdateTranscriptRoutingSettingsRequest {
    updateTranscriptRoutingRequest: UpdateTranscriptRoutingRequest;
}

/**
 * 
 */
export class BotApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async createBotRaw(requestParameters: CreateBotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotInListDTO>> {
        if (requestParameters['createBotRequest'] == null) {
            throw new runtime.RequiredError(
                'createBotRequest',
                'Required parameter "createBotRequest" was null or undefined when calling createBot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createBotRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createBot(requestParameters: CreateBotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotInListDTO> {
        const response = await this.createBotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteByPublicBotIdRaw(requestParameters: DeleteByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling deleteByPublicBotId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteByPublicBotId(requestParameters: DeleteByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteByPublicBotIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotByIdRaw(requestParameters: GetBotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullBotUi>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getBotById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotById(requestParameters: GetBotByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullBotUi> {
        const response = await this.getBotByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotLeadSettingsRaw(requestParameters: GetBotLeadSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeadSettingsResponse>> {
        if (requestParameters['botPublicId'] == null) {
            throw new runtime.RequiredError(
                'botPublicId',
                'Required parameter "botPublicId" was null or undefined when calling getBotLeadSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{botPublicId}/lead-settings`.replace(`{${"botPublicId"}}`, encodeURIComponent(String(requestParameters['botPublicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotLeadSettings(requestParameters: GetBotLeadSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeadSettingsResponse> {
        const response = await this.getBotLeadSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BotOptionDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BotOptionDTO>> {
        const response = await this.getBotOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotToolSettingsRaw(requestParameters: GetBotToolSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToolSettingsResponse>> {
        if (requestParameters['botPublicId'] == null) {
            throw new runtime.RequiredError(
                'botPublicId',
                'Required parameter "botPublicId" was null or undefined when calling getBotToolSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{botPublicId}/tool-settings`.replace(`{${"botPublicId"}}`, encodeURIComponent(String(requestParameters['botPublicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotToolSettings(requestParameters: GetBotToolSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToolSettingsResponse> {
        const response = await this.getBotToolSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBotsTableRaw(requestParameters: GetBotsTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotTableResponse>> {
        if (requestParameters['botTableRequest'] == null) {
            throw new runtime.RequiredError(
                'botTableRequest',
                'Required parameter "botTableRequest" was null or undefined when calling getBotsTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot/table`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['botTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBotsTable(requestParameters: GetBotsTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotTableResponse> {
        const response = await this.getBotsTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmailSendingLogsRaw(requestParameters: GetEmailSendingLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailSendingLogTableResponse>> {
        if (requestParameters['botPublicId'] == null) {
            throw new runtime.RequiredError(
                'botPublicId',
                'Required parameter "botPublicId" was null or undefined when calling getEmailSendingLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{botPublicId}/email-sending-logs`.replace(`{${"botPublicId"}}`, encodeURIComponent(String(requestParameters['botPublicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getEmailSendingLogs(requestParameters: GetEmailSendingLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailSendingLogTableResponse> {
        const response = await this.getEmailSendingLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTranscriptRoutingSettingsRaw(requestParameters: GetTranscriptRoutingSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscriptRoutingSettingsResponse>> {
        if (requestParameters['botPublicId'] == null) {
            throw new runtime.RequiredError(
                'botPublicId',
                'Required parameter "botPublicId" was null or undefined when calling getTranscriptRoutingSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/bot/{botPublicId}/transcript-routing`.replace(`{${"botPublicId"}}`, encodeURIComponent(String(requestParameters['botPublicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTranscriptRoutingSettings(requestParameters: GetTranscriptRoutingSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscriptRoutingSettingsResponse> {
        const response = await this.getTranscriptRoutingSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBotRaw(requestParameters: UpdateBotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BotInListDTO>> {
        if (requestParameters['updateBotRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBotRequest',
                'Required parameter "updateBotRequest" was null or undefined when calling updateBot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateBotRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateBot(requestParameters: UpdateBotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BotInListDTO> {
        const response = await this.updateBotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBotFeedbackSettingsRaw(requestParameters: UpdateBotFeedbackSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeedbackSettingsResponse>> {
        if (requestParameters['updateBotFeedbackSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBotFeedbackSettingsRequest',
                'Required parameter "updateBotFeedbackSettingsRequest" was null or undefined when calling updateBotFeedbackSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot/feedback-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateBotFeedbackSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateBotFeedbackSettings(requestParameters: UpdateBotFeedbackSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeedbackSettingsResponse> {
        const response = await this.updateBotFeedbackSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBotLeadSettingsRaw(requestParameters: UpdateBotLeadSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeadSettingsResponse>> {
        if (requestParameters['updateBotLeadSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBotLeadSettingsRequest',
                'Required parameter "updateBotLeadSettingsRequest" was null or undefined when calling updateBotLeadSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot/lead-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateBotLeadSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateBotLeadSettings(requestParameters: UpdateBotLeadSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeadSettingsResponse> {
        const response = await this.updateBotLeadSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateBotToolSettingsRaw(requestParameters: UpdateBotToolSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToolSettingsResponse>> {
        if (requestParameters['updateBotToolSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBotToolSettingsRequest',
                'Required parameter "updateBotToolSettingsRequest" was null or undefined when calling updateBotToolSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot/tool-settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateBotToolSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateBotToolSettings(requestParameters: UpdateBotToolSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToolSettingsResponse> {
        const response = await this.updateBotToolSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTranscriptRoutingSettingsRaw(requestParameters: UpdateTranscriptRoutingSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscriptRoutingSettingsResponse>> {
        if (requestParameters['updateTranscriptRoutingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTranscriptRoutingRequest',
                'Required parameter "updateTranscriptRoutingRequest" was null or undefined when calling updateTranscriptRoutingSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/bot/transcript-routing`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateTranscriptRoutingRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateTranscriptRoutingSettings(requestParameters: UpdateTranscriptRoutingSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscriptRoutingSettingsResponse> {
        const response = await this.updateTranscriptRoutingSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
